import * as React from 'react';
// form
import { useFormContext, Controller } from "react-hook-form";
import { Box, TextField, Autocomplete, Typography, Stack } from '@mui/material';

export default function RHFCountrySelect({ name, label, onChange: ignored }) {
  const { control } = useFormContext();
  
  return (
    <Controller
      name={name}
      control={control}
      render={(props) => (
        <Autocomplete
          fullWidth
          id="country-select"
          options={countries}
          autoHighlight
          value={props.field.value}
          onChange={(_, values) => props.field.onChange(values)}
          isOptionEqualToValue={(option, value) => option.code === value.code}
          getOptionLabel={(option) => `${option.label} (+${option.phone})`}
          renderOption={(props, option) => (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                alt=""
              />
              {option.label} +{option.phone} ({option.code})
            </Box>
          )}
          renderInput={(params) => (
            <Stack spacing={1} sx={{ width: 1 }}>
              <Typography variant="subtitle2">
                {label}
              </Typography>
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password', // disable autocomplete and autofill
                }}
              />
            </Stack>
          )}
        />
      )}
    />
  );
}

const countries = [
  { code: 'GH', label: '가나', phone: '233' },
  { code: 'GA', label: '가봉', phone: '241' },
  { code: 'GY', label: '가이아나', phone: '592' },
  { code: 'GM', label: '감비아', phone: '220' },
  { code: 'GG', label: '건지섬', phone: '44' },
  { code: 'GP', label: '과들루프', phone: '590' },
  { code: 'GT', label: '과테말라', phone: '502' },
  { code: 'GU', label: '괌', phone: '1-671' },
  { code: 'GD', label: '그레나다', phone: '1-473' },
  { code: 'GR', label: '그리스', phone: '30' },
  { code: 'GL', label: '그린란드', phone: '299' },
  { code: 'GN', label: '기니', phone: '224' },
  { code: 'GW', label: '기니비사우', phone: '245' },
  { code: 'NA', label: '나미비아', phone: '264' },
  { code: 'NR', label: '나우루', phone: '674' },
  { code: 'NG', label: '나이지리아', phone: '234' },
  { code: 'AQ', label: '남극', phone: '672' },
  { code: 'SS', label: '남수단', phone: '211' },
  { code: 'ZA', label: '남아프리카 공화국', phone: '27' },
  { code: 'NL', label: '네덜란드', phone: '31' },
  { code: 'NP', label: '네팔', phone: '977' },
  { code: 'NO', label: '노르웨이', phone: '47' },
  { code: 'NF', label: '노퍽섬', phone: '672' },
  { code: 'NC', label: '누벨칼레도니', phone: '687' },
  { code: 'NZ', label: '뉴질랜드', phone: '64' },
  { code: 'NU', label: '니우에', phone: '683' },
  { code: 'NE', label: '니제르', phone: '227' },
  { code: 'NI', label: '니카라과', phone: '505' },
  { code: 'KR', label: '대한민국', phone: '82' },
  { code: 'DK', label: '덴마크', phone: '45' },
  { code: 'DO', label: '도미니카 공화국', phone: '1-809' },
  { code: 'DM', label: '도미니카 연방', phone: '1-767' },
  { code: 'DE', label: '독일', phone: '49' },
  { code: 'TL', label: '동티모르', phone: '670' },
  { code: 'LA', label: '라오스', phone: '856' },
  { code: 'LR', label: '라이베리아', phone: '231' },
  { code: 'LV', label: '라트비아', phone: '371' },
  { code: 'RU', label: '러시아', phone: '7' },
  { code: 'LB', label: '레바논', phone: '961' },
  { code: 'LS', label: '레소토', phone: '266' },
  { code: 'RE', label: '레위니옹', phone: '262' },
  { code: 'RO', label: '루마니아', phone: '40' },
  { code: 'LU', label: '룩셈부르크', phone: '352' },
  { code: 'RW', label: '르완다', phone: '250' },
  { code: 'LY', label: '리비아', phone: '218' },
  { code: 'LT', label: '리투아니아', phone: '370' },
  { code: 'LI', label: '리히텐슈타인', phone: '423' },
  { code: 'MG', label: '마다가스카르', phone: '261' },
  { code: 'MQ', label: '마르티니크', phone: '596' },
  { code: 'MH', label: '마셜 제도', phone: '692' },
  { code: 'YT', label: '마요트', phone: '262' },
  { code: 'MO', label: '마카오', phone: '853' },
  { code: 'MW', label: '말라위', phone: '265' },
  { code: 'MY', label: '말레이시아', phone: '60' },
  { code: 'ML', label: '말리', phone: '223' },
  { code: 'IM', label: '맨섬', phone: '44' },
  { code: 'MX', label: '멕시코', phone: '52' },
  { code: 'MC', label: '모나코', phone: '377' },
  { code: 'MA', label: '모로코', phone: '212' },
  { code: 'MU', label: '모리셔스', phone: '230' },
  { code: 'MR', label: '모리타니', phone: '222' },
  { code: 'MZ', label: '모잠비크', phone: '258' },
  { code: 'ME', label: '몬테네그로', phone: '382' },
  { code: 'MS', label: '몬트세랫', phone: '1-664' },
  { code: 'MD', label: '몰도바', phone: '373' },
  { code: 'MV', label: '몰디브', phone: '960' },
  { code: 'MT', label: '몰타', phone: '356' },
  { code: 'MN', label: '몽골', phone: '976' },
  { code: 'US', label: '미국', phone: '1' },
  { code: 'VI', label: '미국령 버진아일랜드', phone: '1-340' },
  { code: 'MM', label: '미얀마', phone: '95' },
  { code: 'FM', label: '미크로네시아 연방', phone: '691' },
  { code: 'VU', label: '바누아투', phone: '678' },
  { code: 'BH', label: '바레인', phone: '973' },
  { code: 'BB', label: '바베이도스', phone: '1-246' },
  { code: 'VA', label: '바티칸 시국', phone: '379' },
  { code: 'BS', label: '바하마', phone: '1-242' },
  { code: 'BD', label: '방글라데시', phone: '880' },
  { code: 'BM', label: '버뮤다', phone: '1-441' },
  { code: 'BJ', label: '베냉', phone: '229' },
  { code: 'VE', label: '베네수엘라', phone: '58' },
  { code: 'VN', label: '베트남', phone: '84' },
  { code: 'BE', label: '벨기에', phone: '32' },
  { code: 'BY', label: '벨라루스', phone: '375' },
  { code: 'BZ', label: '벨리즈', phone: '501' },
  { code: 'BA', label: '보스니아 헤르체고비나', phone: '387' },
  { code: 'BW', label: '보츠와나', phone: '267' },
  { code: 'BO', label: '볼리비아', phone: '591' },
  { code: 'BI', label: '부룬디', phone: '257' },
  { code: 'BF', label: '부르키나파소', phone: '226' },
  { code: 'BV', label: '부베섬', phone: '47' },
  { code: 'BT', label: '부탄', phone: '975' },
  { code: 'MP', label: '북마리아나 제도', phone: '1-670' },
  { code: 'MK', label: '북마케도니아', phone: '389' },
  { code: 'BG', label: '불가리아', phone: '359' },
  { code: 'BR', label: '브라질', phone: '55' },
  { code: 'BN', label: '브루나이', phone: '673' },
  { code: 'WS', label: '사모아', phone: '685' },
  { code: 'SA', label: '사우디아라비아', phone: '966' },
  { code: 'GS', label: '사우스조지아 사우스샌드위치 제도', phone: '500' },
  { code: 'SM', label: '산마리노', phone: '378' },
  { code: 'ST', label: '상투메 프린시페', phone: '239' },
  { code: 'MF', label: '생마르탱', phone: '590' },
  { code: 'BL', label: '생바르텔레미', phone: '590' },
  { code: 'PM', label: '생피에르 미클롱', phone: '508' },
  { code: 'EH', label: '서사하라', phone: '212' },
  { code: 'SN', label: '세네갈', phone: '221' },
  { code: 'RS', label: '세르비아', phone: '381' },
  { code: 'SC', label: '세이셸', phone: '248' },
  { code: 'LC', label: '세인트루시아', phone: '1-758' },
  { code: 'VC', label: '세인트빈센트 그레나딘', phone: '1-784' },
  { code: 'KN', label: '세인트키츠 네비스', phone: '1-869' },
  { code: 'SH', label: '세인트헬레나', phone: '290' },
  { code: 'SO', label: '소말리아', phone: '252' },
  { code: 'SB', label: '솔로몬 제도', phone: '677' },
  { code: 'SD', label: '수단', phone: '249' },
  { code: 'SR', label: '수리남', phone: '597' },
  { code: 'LK', label: '스리랑카', phone: '94' },
  { code: 'SJ', label: '스발바르 얀마옌', phone: '47' },
  { code: 'SE', label: '스웨덴', phone: '46' },
  { code: 'CH', label: '스위스', phone: '41' },
  { code: 'ES', label: '스페인', phone: '34' },
  { code: 'SK', label: '슬로바키아', phone: '421' },
  { code: 'SI', label: '슬로베니아', phone: '386' },
  { code: 'SY', label: '시리아', phone: '963' },
  { code: 'SL', label: '시에라리온', phone: '232' },
  { code: 'SX', label: '신트마르턴', phone: '1-721' },
  { code: 'SG', label: '싱가포르', phone: '65' },
  { code: 'AE', label: '아랍에미리트', phone: '971' },
  { code: 'AW', label: '아루바', phone: '297' },
  { code: 'AM', label: '아르메니아', phone: '374' },
  { code: 'AR', label: '아르헨티나', phone: '54' },
  { code: 'AS', label: '아메리칸사모아', phone: '1-684' },
  { code: 'IS', label: '아이슬란드', phone: '354' },
  { code: 'HT', label: '아이티', phone: '509' },
  { code: 'IE', label: '아일랜드', phone: '353' },
  { code: 'AZ', label: '아제르바이잔', phone: '994' },
  { code: 'AF', label: '아프가니스탄', phone: '93' },
  { code: 'AD', label: '안도라', phone: '376' },
  { code: 'AL', label: '알바니아', phone: '355' },
  { code: 'DZ', label: '알제리', phone: '213' },
  { code: 'AO', label: '앙골라', phone: '244' },
  { code: 'AG', label: '앤티가 바부다', phone: '1-268' },
  { code: 'AI', label: '앵귈라', phone: '1-264' },
  { code: 'ER', label: '에리트레아', phone: '291' },
  { code: 'SZ', label: '에스와티니', phone: '268' },
  { code: 'EE', label: '에스토니아', phone: '372' },
  { code: 'EC', label: '에콰도르', phone: '593' },
  { code: 'ET', label: '에티오피아', phone: '251' },
  { code: 'SV', label: '엘살바도르', phone: '503' },
  { code: 'GB', label: '영국', phone: '44' },
  { code: 'VG', label: '영국령 버진아일랜드', phone: '1-284' },
  { code: 'IO', label: '영국령 인도양 지역', phone: '246' },
  { code: 'YE', label: '예멘', phone: '967' },
  { code: 'OM', label: '오만', phone: '968' },
  { code: 'AU', label: '오스트레일리아', phone: '61' },
  { code: 'AT', label: '오스트리아', phone: '43' },
  { code: 'HN', label: '온두라스', phone: '504' },
  { code: 'AX', label: '올란드 제도', phone: '358' },
  { code: 'WF', label: '왈리스 푸투나', phone: '681' },
  { code: 'JO', label: '요르단', phone: '962' },
  { code: 'UG', label: '우간다', phone: '256' },
  { code: 'UY', label: '우루과이', phone: '598' },
  { code: 'UZ', label: '우즈베키스탄', phone: '998' },
  { code: 'UA', label: '우크라이나', phone: '380' },
  { code: 'IQ', label: '이라크', phone: '964' },
  { code: 'IR', label: '이란', phone: '98' },
  { code: 'IL', label: '이스라엘', phone: '972' },
  { code: 'EG', label: '이집트', phone: '20' },
  { code: 'IT', label: '이탈리아', phone: '39' },
  { code: 'IN', label: '인도', phone: '91' },
  { code: 'ID', label: '인도네시아', phone: '62' },
  { code: 'JP', label: '일본', phone: '81' },
  { code: 'JM', label: '자메이카', phone: '1-876' },
  { code: 'ZM', label: '잠비아', phone: '260' },
  { code: 'JE', label: '저지섬', phone: '44' },
  { code: 'GQ', label: '적도 기니', phone: '240' },
  { code: 'KP', label: '조선민주주의인민공화국', phone: '850' },
  { code: 'GE', label: '조지아', phone: '995' },
  { code: 'CN', label: '중국', phone: '86' },
  { code: 'CF', label: '중앙아프리카 공화국', phone: '236' },
  { code: 'TW', label: '중화민국', phone: '886' },
  { code: 'DJ', label: '지부티', phone: '253' },
  { code: 'GI', label: '지브롤터', phone: '350' },
  { code: 'ZW', label: '짐바브웨', phone: '263' },
  { code: 'TD', label: '차드', phone: '235' },
  { code: 'CZ', label: '체코', phone: '420' },
  { code: 'CL', label: '칠레', phone: '56' },
  { code: 'CM', label: '카메룬', phone: '237' },
  { code: 'CV', label: '카보베르데', phone: '238' },
  { code: 'KZ', label: '카자흐스탄', phone: '7' },
  { code: 'QA', label: '카타르', phone: '974' },
  { code: 'KH', label: '캄보디아', phone: '855' },
  { code: 'CA', label: '캐나다', phone: '1' },
  { code: 'KE', label: '케냐', phone: '254' },
  { code: 'KY', label: '케이맨 제도', phone: '1-345' },
  { code: 'KM', label: '코모로', phone: '269' },
  { code: 'XK', label: '코소보', phone: '383' },
  { code: 'CR', label: '코스타리카', phone: '506' },
  { code: 'CC', label: '코코스 제도', phone: '61' },
  { code: 'CI', label: '코트디부아르', phone: '225' },
  { code: 'CO', label: '콜롬비아', phone: '57' },
  { code: 'CG', label: '콩고 공화국', phone: '242' },
  { code: 'CD', label: '콩고 민주 공화국', phone: '243' },
  { code: 'CU', label: '쿠바', phone: '53' },
  { code: 'KW', label: '쿠웨이트', phone: '965' },
  { code: 'CK', label: '쿡 제도', phone: '682' },
  { code: 'CW', label: '퀴라소', phone: '599' },
  { code: 'HR', label: '크로아티아', phone: '385' },
  { code: 'CX', label: '크리스마스섬', phone: '61' },
  { code: 'KG', label: '키르기스스탄', phone: '996' },
  { code: 'KI', label: '키리바시', phone: '686' },
  { code: 'CY', label: '키프로스', phone: '357' },
  { code: 'TJ', label: '타지키스탄', phone: '992' },
  { code: 'TZ', label: '탄자니아', phone: '255' },
  { code: 'TH', label: '태국', phone: '66' },
  { code: 'TC', label: '터크스 케이커스 제도', phone: '1-649' },
  { code: 'TR', label: '터키', phone: '90' },
  { code: 'TG', label: '토고', phone: '228' },
  { code: 'TK', label: '토켈라우', phone: '690' },
  { code: 'TO', label: '통가', phone: '676' },
  { code: 'TM', label: '투르크메니스탄', phone: '993' },
  { code: 'TV', label: '투발루', phone: '688' },
  { code: 'TN', label: '튀니지', phone: '216' },
  { code: 'TT', label: '트리니다드 토바고', phone: '1-868' },
  { code: 'PA', label: '파나마', phone: '507' },
  { code: 'PY', label: '파라과이', phone: '595' },
  { code: 'PK', label: '파키스탄', phone: '92' },
  { code: 'PG', label: '파푸아뉴기니', phone: '675' },
  { code: 'PW', label: '팔라우', phone: '680' },
  { code: 'PS', label: '팔레스타인', phone: '970' },
  { code: 'FO', label: '페로 제도', phone: '298' },
  { code: 'PE', label: '페루', phone: '51' },
  { code: 'PT', label: '포르투갈', phone: '351' },
  { code: 'FK', label: '포클랜드 제도', phone: '500' },
  { code: 'PL', label: '폴란드', phone: '48' },
  { code: 'PR', label: '푸에르토리코', phone: '1' },
  { code: 'FR', label: '프랑스', phone: '33' },
  { code: 'GF', label: '프랑스령 기아나', phone: '594' },
  { code: 'TF', label: '프랑스령 남방 및 남극 지역', phone: '262' },
  { code: 'PF', label: '프랑스령 폴리네시아', phone: '689' },
  { code: 'FJ', label: '피지', phone: '679' },
  { code: 'FI', label: '핀란드', phone: '358' },
  { code: 'PH', label: '필리핀', phone: '63' },
  { code: 'PN', label: '핏케언 제도', phone: '870' },
  { code: 'HM', label: '허드 맥도널드 제도', phone: '672' },
  { code: 'HU', label: '헝가리', phone: '36' },
  { code: 'HK', label: '홍콩', phone: '852' }
];
